import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locale } from '@/shared/localization/enumerations/Locale';
import { localizationMessages } from '@/translations';

/**
 * Custom pluralization rule for uk and ru locales
 * Define translation key as '{n} === 0 | {n} ends with 1 | {n} ends with 2-4 | {n} ends with 5-9 OR {n} in 11-19'
 * @returns Index of translation option
 * @param {number} choice Pluralization counter passed into $tc
 * @param {number} choicesLength Lenght of translation options array
 */
const slavicPluralization = (choice: number, choicesLength: number) => {
  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (choicesLength < 4) {
    return !teen && endsWithOne ? 1 : 2;
  }
  if (!teen && endsWithOne) {
    return 1;
  }
  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return choicesLength < 4 ? 2 : 3;
};

const appDataAvailableLanguages = window.APP_DATA.preferences.locales;

const allMessages = { ...localizationMessages };
const messages = { ...allMessages };
let fallbackLocale = Locale.English as string;
let locale = window.APP_DATA.language || Locale.Ukrainian;

if (
  appDataAvailableLanguages.length &&
  Object.keys(allMessages).some(lang => appDataAvailableLanguages.includes(lang))
) {
  Object.keys(allMessages).forEach(lang => {
    if (!appDataAvailableLanguages.includes(lang)) {
      delete messages[lang];
    }
  });

  if (!appDataAvailableLanguages.includes(fallbackLocale)) {
    fallbackLocale = appDataAvailableLanguages[0];
  }

  if (!appDataAvailableLanguages.includes(locale)) {
    locale = appDataAvailableLanguages[0];
  }
}

Vue.use(VueI18n);

export const languages = Object.keys(messages);

export const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale,
  fallbackLocale,
  messages,
  pluralizationRules: {
    ru: slavicPluralization,
    uk: slavicPluralization,
  },
});
